<zimmerer-route-ion-wrapper class="ion-page">

  <script src="https://player.vimeo.com/api/player.js"></script>

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col withBottomPadding" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <div fxHide.gt-md fxLayout="column" fxLayoutGap="5px">
        <div style="text-align: center;">Blog</div>
        <h2 class="listHeadline">Der Blog für Zimmerer-Themen. <br> Neues erfahren und selber posten!</h2>
      </div>

      <image-slider [fxHide]="!hasSliderImages" [page]="'blog'" fxHide.lt-lg></image-slider>

      <app-searchbar (onSearch)="changeFilter($event.filter,'string',$event.value)"
        (onPreflightSearch)="onPreflightSearch($event)" [preflightValues]="preflightValues" entityTypeIdentifier="blog">
      </app-searchbar>

      <!-- MOBILE only - local create button -->
      <button fxHide.gt-md class="orange-button create-btn" (click)="StateService.goto('/blog/create',{},true,true)">
        Beitrag erstellen
      </button>

      <!-- MOBILE only - show filter toggle button -->
      <button fxHide.gt-md class="mobileGrowBtn unselectable" (click)="changeFilter('filtersopen','boolean')">
        {{ StateService.queryParams['filtersopen'] ? 'Kategorieauswahl schließen' : 'Kategorie auswählen' }}
      </button>

      <!-- category filter btns -->
      <div fxLayout.gt-md="row wrap" fxLayout.lt-lg="column" fxLayoutGap="10px"
        *ngIf="!MobileService.isMobile || StateService.queryParams['filtersopen']">
        <button class="katfilterbtn" [class.selected]="!catFilterSet()"
          (click)="changeFilter('blog_category_id','number',null)">
          Alle Kategorien
        </button>
        <button class="katfilterbtn"
          [class.selected]="catFilterSet() && StateService.queryParams['blog_category_id'] == category.id"
          *ngFor="let category of categories" (click)="changeFilter('blog_category_id','number',category.id)">
          {{category.name.toLowerCase().includes('video') ? category.name.toUpperCase() : category.name }}
        </button>
      </div>

      <!-- grid -->
      <div class="grid" *ngIf="pagination && pagination.values; else noHits;">
        <blog-card *ngFor="let e of pagination.values" [entity]="e" #impressionAnchor data-entitytype="Blog"
          data-id="{{e.id}}">
        </blog-card>
      </div>
      <ng-template #noHits>
        <b>{{!LoadingService.isLoading ? 'Für deine Suche / Filter gibt es leider keine Treffer.' : ''}}</b>
      </ng-template>

      <app-pagination [pagination]="pagination" [stateParams]="StateService.queryParams"
        (onGotoPage)="changeFilter($event.filter,'number',$event.value)">
      </app-pagination>

      <app-blog-related-items direction="horizontal" title="Das hat deine Kollegen interessiert"
        [items]="mostViewed"></app-blog-related-items>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>